export const remuneration = {
  personnalise_rates_ref: {
    table: {
      title: 'Liste des taux de référence personnalisés',
      personnalise_rates_button: 'Taux personnalisés',
      title_modal_rate: 'Liste des cours',
      message_confirm:
        'La date existe déjà dans le tableau,voulez-vous continuer',
      columns: {
        plancher: 'Plancher',
        name: 'Nom',
        plancher_rates: 'Taux Plancher',
        plafond_rates: 'Taux Plafond',
        plafond: 'Plafond',
      },
      modal: {
        date: 'Date de mise à jour',
        name: 'Nom',
        cours: 'Cours',
        confirmMessage:
          ' Voulez-vous mettre à jour les cours à la date {{date}}. \n Toutes les lignes qui ont une valeur sont soit  créées soit mise à jour',
      },
    },
    fiche: {
      edit_title: 'Fiche du taux de référence personnalisé {{name}}',
      new_title: "Création d'un nouveau taux de référence personnalisé",
      champ_titles: {
        debut_date: 'Date de début',
        finish_date: 'Date de fin',
        rate_type: 'Type de taux',
        value: 'Valeur',
        taux_value: 'Taux Valeur',
        condition: 'Condition Fixing',
        plancher_rates_floor: 'Taux plancher - Floor',
        plafond_rates_cap: 'Taux plafond - Cap',
        plancher_rates: 'Taux Plancher',
        plafond_rates: 'Taux Plafond',
        name: 'Nom',
      },
    },
    cours: {
      title: 'Cours du taux {{name}}',
      titleDrawer: 'Liste',
      visu: 'Contrôle des cours',
      columns: {
        update_timestamp: 'Date de modification',
        rate: 'Cours',
      },
      columnsDrawer: {
        date: 'Date',
        error: 'Erreur',
        aucunErreur: "Aucune erreur n'a été trouvée",
      },
      button: {
        update: 'Mise à jour',
        verify: 'Contrôle des taux ',
      },
      modal: {
        start_date: 'Date de début',
        end_date: 'Date de fin',
        rate: 'Cours',
        title: "Ajout d'un cours",
        update: "Mise à jour d'un cours",
      },
    },
  },
  personnalise_rates: {
    table: {
      title: 'Liste des taux personnalisés',
      button_charg_rate: 'Chargement Cours',
      columns: {
        name: 'Nom',
        rates: 'Taux directeur',
        rate_marge: 'Taux/Marge',
        base_calcul: 'Base Calcul',
        rate_type: 'Type Taux',
        conv: 'Convention',
      },
    },
    fiche: {
      edit_title: 'Fiche du taux personnalisé {{name}}',
      new_title: "Création d'un nouveau taux personnalisé",
      champ_titles: {
        base_calcul: 'Base Calcul',
        conv: 'Convention',
        type: 'Type',
        rate_value: 'Valeur Taux',
        rate_marge: 'Taux/Marge',
        comment: 'Commentaire',
        plancher_rates_floor: 'Taux plancher - Floor',
        plafond_rates_cap: 'Taux plafond - Cap',
        plancher_rates: 'Taux Plancher',
        plafond_rates: 'Taux Plafond',
        name: 'Nom',
        value_floor_rate: 'Taux personnalisé plafond',
        value_rate_cap: 'Taux personnalisé plancher',
      },
      cap_floor_area: 'Cap et Floor sur Taux + Marge',
    },
  },
}

